function addVatToPrice (price, vat) {
  return price + (price * vat) / 100
}

function resetAndSetupDataLayer() {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = []
  }
  window.dataLayer.push({ ecommerce: null })
}

function parseProductsDataToDataLayer(products) {
  let totalPriceWithVat = 0
  const dataProducts = products.map((product, productIndex) => {
    let category1 = ''
    let category2 = ''
    if (product.categories && product.categories.length > 0) {
      product.categories.forEach((category, categoryIndex) => {
        if (categoryIndex === 0) {
          category1 = category.name
        } else if (categoryIndex === 1) {
          category2 = category.name
        }
      })
    }

    const priceWithVat = addVatToPrice(product.price, product.vat)
    let discountPriceWithVat = null
    if (product.discountPrice) {
      discountPriceWithVat = priceWithVat - addVatToPrice(product.discountPrice, product.vat)
    }
    if (discountPriceWithVat !== null) {
      totalPriceWithVat += discountPriceWithVat * product.quantity
    } else {
      totalPriceWithVat += priceWithVat * product.quantity
    }

    const variants = []
    if (product.parameters) {
      product.parameters.forEach(parameter => {
        variants.push(`${parameter.name}: ${parameter.value}`)
      })
    }

    return {
      index: productIndex,
      item_id: product.productCode || product.id,
      item_name: product.name,
      item_brand: '',
      item_category: category1,
      item_category2: category2,
      item_variant: variants.join(', '),
      price: priceWithVat,
      discount: discountPriceWithVat || 0,
      quantity: product.quantity,
    }
  })
  
  return {
    currency: 'EUR',
    value: totalPriceWithVat,
    items: dataProducts
  }
}

export function ecommerceAddShippingInfo(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'add_shipping_info',
      ecommerce: {
        ...parseProductsDataToDataLayer(data.products),
        coupon: data.bonusCode || '',
        shipping_tier: '',
      },
    })
}

export function ecommerceAddPaymentInfo(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'add_payment_info',
      ecommerce: {
        ...parseProductsDataToDataLayer(data.products),
        coupon: data.bonusCode || '',
        payment_type: 'Bank',
      },
    })
}

export function ecommerceBeginCheckout(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: {
        ...parseProductsDataToDataLayer(data.products),
        coupon: data.bonusCode || '',
      },
    })
}

export function ecommercePurchase(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        ...parseProductsDataToDataLayer(data.products),
        coupon: data.bonusCode || '',
        transaction_id: data.transactionId || '',
      },
    })
}

export function ecommerceAddToCart(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: parseProductsDataToDataLayer(data.products),
    })
}

export function ecommerceRemoveFromCart(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: parseProductsDataToDataLayer(data.products),
    })
}

export function ecommerceViewCart(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: parseProductsDataToDataLayer(data.products),
    })
}

export function ecommerceViewItemList(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        ...parseProductsDataToDataLayer(data.products),
        item_list_id: '',
        item_list_name: 'Tooted',
      },
    })
}

export function ecommerceViewItem(data) {
  resetAndSetupDataLayer()
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: parseProductsDataToDataLayer(data.products),
    })
}
